import { FormSelect } from "react-bootstrap";
import { AnalysisType, getDepthMax } from "./addressAPI";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "@/app/hooks";
import {
  blockchainTranslate,
  reverseAnalysisData,
  selectAnalysisError,
  selectAnalysisList,
  selectAssetNav,
  selectLoadScorigingAnalysis,
  showAssets,
} from "./addressSlice";
import LoadingIcon from "@/features/common/loading";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import {
  Button,
  Col,
  Form,
  Input,
  Row,
  Space,
  Modal,
  Table,
  Tag,
  Tooltip,
  Badge,
} from "antd";
import dayjs from "dayjs";
import type { ColumnsType, TableProps } from "antd/es/table";
import { Link } from "react-router-dom";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import line_direct from "@/assets/line_direct.png"
import line_indirect from "@/assets/line_indirect.png"
import line_direct_b from "@/assets/line_direct_b.png"
import line_indirect_b from "@/assets/line_indirect_b.png"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
export default function RiskScoreList(props: {
  depth?: number;
  symbol: string;
  showAssets: boolean;
  onChangeType: Function;
  onChangeSelect?: Function;
  onChangeDepth?: Function;
}) {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  const [dataType, setDataType] = useState(1);
  const [selectNavIndex, setNavIndex] = useState(0);

  const assetNav = useAppSelector(selectAssetNav);
  const analysisList = useAppSelector(selectAnalysisList);
  const loadAnalysisData = useAppSelector(selectLoadScorigingAnalysis);
  const loadAnalysisError = useAppSelector(selectAnalysisError);
  const { blockchain } = useParams();
  const depthMax = getDepthMax(blockchain || '')

  const [inputData, setInputData] = useState(0)
  const [show, setShow] = useState(false)
  const changeType = (type: AnalysisType, status: number) => {
    if (loadAnalysisData) return;

    setDataType(status);
    props.onChangeType(type);
  };

  const columns: ColumnsType<any> = [
    {
      title: "Percentage",
      dataIndex: "percentage",
      key: "percentage",
      width: 120,
      fixed: true,
      render: (i) => {
        return <>{i.toFixed(6)}%</>;
      },
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 150,
      ellipsis: true,
      fixed: true,
      render: (i) => {
        return (
          <Tooltip placement="topLeft" title={i}>
            {i}
          </Tooltip>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      width: 150,
    },
    {
      title: "Countervalue(USD)",
      dataIndex: "amountUsd",
      key: "amountUsd",
      width: 200,
    },
    {
      title: `Amount ${props.symbol ? `(${props?.symbol == '-' ? 'N/A' : props?.symbol})` : ""}`,
      dataIndex: "amount",
      key: "amount",
      width: 150,
      render: (i) => {
        return <>{props?.symbol == '-' ? 'N/A' : i}</>;
      },
    },
    {
      title: "Score",
      dataIndex: "score",
      key: "score",
      width: 80,
    },
  ];
  const onChangeDepth = (depth: number) => {
    setShow(false)
    props.onChangeDepth && props.onChangeDepth(depth)
  }
  return (
    <>
      <div>
        <div className="title-wrap">
          <p className="title">Risk Assessment</p>
          <div>
            <div className="select-cpt">
              {
                props.depth &&
                <>
                  <div className={props.depth == 1 ? "select-btn-open" : "select-btn"} onClick={() => onChangeDepth(1)}>
                    <img className="select-direct-img" src={props.depth == 1 ? line_direct : line_direct_b} />
                    <div className={props.depth == 1 ? "select-direct-txt2" : "select-direct-txt"}>{t("address.riskRank.line_direct")}</div>
                  </div>
                  <OverlayTrigger
                    show={show}
                    trigger="click"
                    placement="top"
                    overlay={
                      <div className='line-tooltip-view' >
                        <div>{t("address.riskRank.line_indirect_on")}</div>
                        <input type="range" className='line-tooltip-range' min={1} max={depthMax} value={inputData} onChange={(e) => {
                          setInputData(Number(e.target.value))
                        }}></input>
                        <input type="number" className='line-tooltip-input' min={1} max={depthMax} value={inputData} onChange={(e) => {
                          if (Number(e.target.value) > depthMax) {
                            setInputData(depthMax)
                          } else if (Number(e.target.value) <= 1) {
                            setInputData(1)
                          } else {
                            setInputData(Number(e.target.value))
                          }
                        }}></input>
                        <div className='line-tooltip-btn' onClick={() => {
                          onChangeDepth(inputData)
                        }}>{t("address.riskRank.line_indirect_submit")}</div>
                      </div>
                    }
                  >
                    <div className={props.depth != 1 ? "select-btn-open" : "select-btn"} onClick={() => {
                      setShow(!show)
                      setInputData(props.depth || 1)
                    }}>
                      <img className="select-direct-img" src={props.depth != 1 ? line_indirect : line_indirect_b} />
                      <div className={props.depth != 1 ? "select-direct-txt2" : "select-direct-txt"}>{t("address.riskRank.line_indirect")}
                        <div >{t("address.riskRank.line_indirect_tip")}{props.depth}</div>
                      </div>
                    </div>
                  </OverlayTrigger>
                </>
              }
              {
                props.showAssets &&
                <FormSelect
                  defaultValue={0}
                  disabled={loadAnalysisData}
                  onChange={(e) => {
                    if (!props.onChangeSelect || !assetNav) return;
                    const index = e.target.selectedIndex;
                    const chainId =
                      index === 0
                        ? "ALL"
                        : assetNav[index - 1].chainId || "MAIN";
                    props.onChangeSelect(chainId, index);
                    setNavIndex(index);
                  }}
                >
                  <option value={0}>{t("address.totalAssets")}</option>
                  {assetNav &&
                    assetNav.map((i, k) => (
                      <option key={i.chainId} value={k + 1}>
                        {blockchainTranslate(i.name)}
                      </option>
                    ))}
                </FormSelect>
              }
            </div>
          </div>
        </div>
        {props.showAssets && (
          <div style={{ fontSize: "12px" }}>
            <ExclamationCircleOutlined
              style={{ color: "#f5222d" }}
              rev={undefined}
            />{" "}
            If the address cannot display the global risk assessment chart, it
            is because the address has more than 10,000 transactions with
            multiple assets. Please select one of the assets on the right and
            assess the risk for each asset separately.
          </div>
        )}

        <nav className="nav-list">
          <li
            className={dataType === 1 ? "active" : ""}
            onClick={() => changeType(AnalysisType.Incoming, 1)}
          >
            Incoming Risk Score
          </li>
          <li
            className={dataType === 2 ? "active" : ""}
            onClick={() => changeType(AnalysisType.Outgoing, 2)}
          >
            Outgoing Risk Score
          </li>
        </nav>
        <Table
          scroll={{ x: 800, y: 490 }}
          columns={columns}
          dataSource={analysisList}
          pagination={{
            showSizeChanger: false,
            total: analysisList.length,
            pageSize: 9,
            onChange: (a) => setPage(a - 1),
          }}
        />
      </div>
    </>
  );
}
